// extracted by mini-css-extract-plugin
export var a = "App-module--a--whKLM";
export var container = "App-module--container--BOtjA";
export var main = "App-module--main--rO-Dt";
export var p = "App-module--p--6R2vA";